import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { KEYS_FIELDS_QUESTION } from 'constants/materialAssessment';
import getValueChainNames from 'utils/valueChainHelpers';

import type IStakeholderGroupsDisclosuresItem from 'store/slices/materialAssessment/interfaces/IStakeholderGroupsDisclosuresItem';
import type IRefinementDisclosuresTable from './interfaces/IRefinementDisclosuresTable';

import styles from './scss/RefinementDisclosuresTable.module.scss';

function RefinementDisclosuresTable({
  headCells,
  items,
  hasMore,
  loadMore,
}: Readonly<IRefinementDisclosuresTable>) {
  const { t } = useTranslation();

  const CELL_ID_TO_KEY: Record<string, string> = {
    disclosure: KEYS_FIELDS_QUESTION.DISCLOSURE,
    category: KEYS_FIELDS_QUESTION.CATEGORY,
    requiredBy: KEYS_FIELDS_QUESTION.REQUIRED_BY,
    country: KEYS_FIELDS_QUESTION.COUNTRY,
    source: KEYS_FIELDS_QUESTION.SOURCEDisc,
    valueChainName: KEYS_FIELDS_QUESTION.VALUE_CHAIN,
  };

  const renderCell = (item: IStakeholderGroupsDisclosuresItem, cellId: string) => {
    const key = CELL_ID_TO_KEY[cellId] ?? cellId;
    switch (key) {
      case KEYS_FIELDS_QUESTION.DISCLOSURE:
        return (
          <span className={styles.cellLabel}>
            {item.title || '-'}
          </span>
        );
      case KEYS_FIELDS_QUESTION.CATEGORY:
        return (
          <span className={styles.cellText}>
            {item.type || '-'}
          </span>
        );
      case KEYS_FIELDS_QUESTION.REQUIRED_BY:
        return (
          <span className={styles.cellText}>
            {item.requiredBy || '-'}
          </span>
        );
      case KEYS_FIELDS_QUESTION.COUNTRY:
        return (
          <span className={styles.cellText}>
            {item.countryRegion || '-'}
          </span>
        );
      case KEYS_FIELDS_QUESTION.SOURCEDisc:
        return (
          <span className={styles.source}>
            {item.source || '-'}
          </span>
        );
      case KEYS_FIELDS_QUESTION.VALUE_CHAIN:
        return (
          <span className={styles.source}>
            {getValueChainNames(item.valueChainMapIds, undefined)}
          </span>
        );
      default:
        return '-';
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.tableScrollWrapper}>
        <div className={styles.tableHeader}>
          {headCells.map(({ id, label }) => (
            <div key={id} className={styles.headerCell}>
              <span>{t(label)}</span>
            </div>
          ))}
        </div>
        <InfiniteScroll
          dataLength={items.length}
          next={loadMore}
          hasMore={hasMore}
          loader={null}
          scrollableTarget="refinement-disclosures-scroll"
        >
          <div className={styles.tableBodyScroll} id="refinement-disclosures-scroll">
            <div className={styles.tableBody}>
              {items.length > 0
                ? items.map((item, index) => (
                  <div key={[item.id, index].join('_')} className={styles.tableRow}>
                    {headCells.map((cell) => (
                      <div key={cell.id} className={styles.tableCell}>
                        {renderCell(item, cell.id)}
                      </div>
                    ))}
                  </div>
                ))
                : null}
            </div>
          </div>
        </InfiniteScroll>
      </div>
    </div>
  );
}

export default RefinementDisclosuresTable;
